module.exports = __webpack_public_path__ + "static/media/10k.853a46ad.svg";